/** Section 5.2 - the one sanctioned way to walk an entity collection (I3). */

import type { EntityMap } from "../state.js";

export function* iterEntities<K extends string, V>(m: EntityMap<K, V>): Generator<[K, V]> {
  const keys = (Object.keys(m) as K[]).sort();
  for (const k of keys) yield [k, m[k]!];
}

export function entityKeys<K extends string, V>(m: EntityMap<K, V>): K[] {
  return (Object.keys(m) as K[]).sort();
}

export function entityValues<K extends string, V>(m: EntityMap<K, V>): V[] {
  return entityKeys(m).map((k) => m[k]!);
}

export function countEntities<K extends string, V>(m: EntityMap<K, V>): number {
  return Object.keys(m).length;
}
